import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "trade-world-map" }
const _hoisted_2 = { class: "trade-world-map__controls" }
const _hoisted_3 = { class: "trade-world-map__popup-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RedesignedSwitchComponent = _resolveComponent("RedesignedSwitchComponent")!
  const _component_MapComponent = _resolveComponent("MapComponent")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RedesignedSwitchComponent, {
        textTrue: _ctx.getFlowTypes[0].label,
        textFalse: _ctx.getFlowTypes[1].label,
        onSwitchHandler: _ctx.onFlowSwitch
      }, null, 8, ["textTrue", "textFalse", "onSwitchHandler"])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", null, [
      _createVNode(_component_MapComponent, {
        geojson: _ctx.getGeojson,
        mapConfig: _ctx.mapConfig,
        isLoading: _ctx.isLoading,
        stateMessage: _ctx.getStateMessage,
        styleFeature: _ctx.styleFeature,
        featureTooltip: _ctx.featureTooltip,
        selectedCode: _ctx.selectedFeatureCode,
        legend: _ctx.getLegend,
        popupOpen: _ctx.popup.isOpen,
        onFeatureClick: _ctx.onFeatureClick,
        onClosePopup: _ctx.closePopup
      }, {
        popupHeader: _withCtx(() => [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.popup.partnerFullName), 1)
        ]),
        popupBody: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPopupRows, (row) => {
            return (_openBlock(), _createElementBlock("p", {
              key: row.label,
              class: "trade-world-map__popup-row"
            }, [
              _createTextVNode(_toDisplayString(row.label) + ": ", 1),
              _createElementVNode("strong", null, _toDisplayString(row.value) + _toDisplayString(row.postfix ? ` ${row.postfix}` : ''), 1)
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["geojson", "mapConfig", "isLoading", "stateMessage", "styleFeature", "featureTooltip", "selectedCode", "legend", "popupOpen", "onFeatureClick", "onClosePopup"])
    ])), [
      [_directive_click_outside, _ctx.closePopup]
    ])
  ]))
}